(() => {
  'use strict';
  if (window.holyRecommendationsLoaded) return;
  window.holyRecommendationsLoaded = true;
  const cleanups = new WeakMap();
  async function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-hs-rec-config]').textContent);
    const track = root.querySelector('[data-hs-rec-track]');
    const readCards = container => [...container.querySelectorAll('[data-hs-rec-card]')].map(node => ({
      node, id:node.dataset.id, handle:node.dataset.handle, title:node.dataset.title,
      tags:node.dataset.tags, price:Number(node.dataset.price), available:true,
      source:node.dataset.source, isKit:node.dataset.kit === 'true'
    }));
    let candidates = readCards(root.querySelector('[data-hs-rec-candidates]').content);
    const controller = new AbortController();
    let resize;
    cleanups.set(root, () => { controller.abort(); resize?.disconnect(); });
    if (config.auto && !config.onlyManual) {
      const timeout = setTimeout(() => controller.abort(), 4000);
      try {
        const response = await fetch(config.url, {signal:controller.signal,headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const template = html.querySelector('[data-hs-rec-response]');
        if (template) candidates = candidates.concat(readCards(template.content));
      } catch (_) {
        // Local, server-rendered choices remain usable when the recommendation service fails.
      } finally { clearTimeout(timeout); }
    }
    if (!root.isConnected) return;
    config.siblingHandles = config.deduplicate
      ? [...document.querySelectorAll('[data-hs-sabores] [data-hs-sab-handle]')].map(card => card.dataset.hsSabHandle) : [];
    const selected = window.HolyRecommendationRules.select(candidates, config);
    track.replaceChildren(...selected.map(item => item.node.cloneNode(true)));
    if (!selected.length) return;
    root.hidden = false;
    const buttons = [...root.querySelectorAll('[data-hs-rec-direction]')];
    const motion = 'smooth';
    const update = () => {
      buttons[0].disabled = track.scrollLeft <= 2;
      buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      const step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
      track.scrollBy({left:Number(button.dataset.hsRecDirection) * step,behavior:motion});
    }));
    track.addEventListener('scroll', update, {passive:true});
    resize = new ResizeObserver(update);
    resize.observe(track);
    update();
    let drag = null, dragged = false;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button,input')) return;
      drag = {x:event.clientX,left:track.scrollLeft,id:event.pointerId}; dragged = false;
    });
    track.addEventListener('pointermove', event => {
      if (!drag) return;
      if (!(event.buttons & 1)) { drag = null; track.classList.remove('is-dragging'); return; }
      const distance = event.clientX - drag.x;
      if (!dragged && Math.abs(distance) < 6) return;
      dragged = true; track.setPointerCapture(drag.id); track.classList.add('is-dragging');
      track.scrollLeft = drag.left - distance; event.preventDefault();
    });
    ['pointerup','pointercancel','lostpointercapture'].forEach(name => track.addEventListener(name,()=>{drag=null;track.classList.remove('is-dragging');}));
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('click', event => {if (dragged) {event.preventDefault();event.stopPropagation();dragged=false;}},true);
    root.addEventListener('submit', async event => {
      const form = event.target.closest('[data-hs-rec-add]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button');
      if (button.disabled) return;
      const status = form.closest('[data-hs-rec-card]').querySelector('.hs-rec-status');
      button.disabled = true; button.textContent = 'Adicionando…'; status.textContent = '';
      const variantId = Number(form.elements.id.value);
      let added = false;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:variantId,quantity:1}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Não foi possível adicionar. Tente novamente.');
        added = true;
        status.textContent = 'Adicionado ao carrinho!'; button.textContent = 'Adicionado ✓';
        window.dispatchEvent(new CustomEvent('cart-change',{detail:{variantId},bubbles:true}));
        // A cart refresh failure must not tell the customer an already accepted add failed.
        try { await window.Alpine?.store('cart')?.fetchItems?.(); } catch (_) {}
      } catch (error) {
        status.textContent = error.message || 'Confira sua conexão e tente novamente.';
      } finally {
        const reset = () => {if (button.isConnected) {button.disabled=false;button.textContent='+ Adicionar';}};
        if (added) setTimeout(reset,1500); else reset();
      }
    });
  }
  const scan = scope => scope.querySelectorAll('[data-hs-recommendations]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-hs-recommendations]').forEach(root=>cleanups.get(root)?.()));
})();
